<!-- 节假日提示语配置 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select class="filter-item" v-model="filters.cat_type" placeholder="品类" style="width:170px" clearable>
                <el-option label="全部" :value="0"></el-option>
                <el-option label="蛋糕" :value="1"></el-option>
                <el-option label="鲜花" :value="2"></el-option>
                <el-option label="蛋糕+鲜花" :value="3"></el-option>
            </el-select>
            <el-select class="filter-item" v-model="filters.status" placeholder="状态" style="width:170px" clearable>
                <el-option label="上架" :value="0"></el-option>
                <el-option label="下架" :value="1"></el-option>
            </el-select>
            <el-date-picker class="filter-item" v-model="filters.start_date" type="date" placeholder="开始日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <span class="filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" type="date" placeholder="结束日期" value-format="YYYY-MM-DD" style="width:170px" clearable></el-date-picker>
            <el-button class="filter-btn" type="primary" @click="onSearch()">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="onEdit()">添加</el-button>
            <el-button class="filter-btn" type="primary" @click="onSearch(1)">待生效</el-button>
            <el-button class="filter-btn" type="primary" @click="onSearch(2)">运用中</el-button>
            <el-button class="filter-btn" type="primary" @click="onSearch(3)">已过期</el-button>
        </div>

        <el-table :data="tableData" border>
            <el-table-column type="index" ></el-table-column>
            <el-table-column label="品类">
                <template #default="scope">
                    <span>{{ FestivalCat[scope.row.cat_type] }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="msg" label="提示语" width="400"></el-table-column>
            <el-table-column prop="start_date" label="开始日期" width="160"></el-table-column>
            <el-table-column prop="end_date" label="结束日期" width="160"></el-table-column>
            <el-table-column label="运行状态" width="90">
                <template #default="scope">
                    <span>{{ new Date(scope.row.end_date + ' 23:59:59') < new Date() ? '已过期': new Date(scope.row.start_date) > new Date() ? '待生效' : '运用中'}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="90">
                <template #default="scope">
                    <span>{{ scope.row.status ? '下架': '上架' }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <div class="action-list">
                        <el-button type="primary" size="small" @click="onEdit(scope.row)">编辑</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
        <!-- <el-pagination
            @current-change="onPageChange"
            :currentPage="filters.page"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination> -->

        <!-- 编辑弹框 -->
        <el-dialog title="节假日提示语配置" v-model="dialogVisible" :before-close="dialogBeforeClose">
            <el-form :model="formData" ref="editForm" :rules="editFormRules" label-width="120px">
                <el-form-item label="开始日期" prop="start_date">
                    <el-date-picker v-model="formData.start_date" placeholder="开始日期" value-format="YYYY-MM-DD" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" prop="end_date">
                    <el-date-picker v-model="formData.end_date" placeholder="结束日期" value-format="YYYY-MM-DD" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="提示语" prop="msg">
                    <el-input type="textarea" v-model="formData.msg" placeholder="请输入提示语内容" maxlength="150" show-word-limit :rows="3" style="width:400px"></el-input>
                </el-form-item>
                <el-form-item label="品类" prop="cat_type">
                    <el-checkbox-group v-model="formData.cat_type">
                        <el-checkbox label="1">蛋糕</el-checkbox>
                        <el-checkbox label="2">鲜花</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="0">上架</el-radio>
                        <el-radio :label="1">下架</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="dialogBeforeClose">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { defineComponent, getCurrentInstance, toRefs, reactive, nextTick } from 'vue'
import { joinParams } from '@/utils'
import { FestivalCat } from '@/enums/activity'
export default defineComponent({
name: 'FestivalTip',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance()

    const state = reactive({
        filters: {
            cat_type:   '',     // 品类：1-蛋糕，2-鲜花，3-蛋糕+鲜花
            status:     '',     // 状态
            start_date: '',     // 开始日期
            end_date:   null,   // 结束日期
            page:       1,      // 当前页码
            page_size:       10,     // 每页显示条数
        },
        total:          0,      // 表格总条数
        tableData:      [],     // 表格数据

        dialogVisible:  false,  // 弹框显隐
        formData: { // 编辑表单数据
            popup_id:   '',     // 当前ID
            start_date: '',     // 开始日期
            end_date:   '',     // 结束日期
            cat_type:   [],     // 品类
            msg:        '',     // 提示语内容
            status:     0       // 状态
        }
    })

    // 获取表格数据
    const getList = (status_type) => {
        let params = status_type ? `status_type=${status_type}` : joinParams(state.filters)
        proxy.$http.get(`/cake_api/festival_popup_list?${params}`).then(res => {
            const { code, data, msg } = res
            if (code != 200) {
                return proxy.$message({ type: 'error', message: msg })
            }
            state.tableData = data.data
            state.total = data.total
        })
    }
    // 搜索
    const onSearch = (status_type) => {
        state.filters.page = 1
        getList(status_type)
    }
    // 添加/编辑
    const onEdit = (row) => {
        if (row) {
            const { cat_type } = row
            nextTick(() => {
                let tmpFormData = {...row}
                tmpFormData.popup_id = tmpFormData.id
                tmpFormData.cat_type = cat_type==3 ? ['1', '2'] : (cat_type+'').split(',')
                state.formData = tmpFormData
            })
        }
        state.dialogVisible = true
    }
    // 换页
    // const onPageChange = (val) => {
    //     state.filters.page = val
    //     getList()
    // }
    const onPageChange = (val) => {
        state.filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        state.filters.page_size = val
        getList()
    }
    // 表格 index 连续
    const tableIndex = (index) => {
        const { page, size } = state.filters
        return (page - 1) * size + index + 1
    }
    // 关闭弹框前清空表单数据
    const dialogBeforeClose = () => {
        proxy.$refs['editForm'].resetFields()
        state.dialogVisible = false
    }
    // 保存表单
    const submitForm = () => {
        proxy.$refs['editForm'].validate((valid) => {
            if (valid) {
                const { formData } = state
                let data = { ...formData }
                let { cat_type } = data
                cat_type = cat_type.join(',')
                if (cat_type == '1,2' || cat_type == '2,1') {
                    cat_type = 3
                }
                data.cat_type = cat_type
                proxy.$http.post('/cake_api/festival_popup_add', data).then(res => {
                    const { code, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    getList()
                    dialogBeforeClose()
                })
            }
        })
    }
    
    // 验证结束日期，不能小于开始日期且不能小于当前日期
    const validEndDate = (rule, val, callback) => {
        const { start_date } = state.formData
        if (val < start_date) {
            callback(new Error('结束日期不能小于开始日期'))
        } else if (new Date(val + ' 23:59:59') < new Date()) {
            callback(new Error('结束日期不能小于当前日期'))
        } else {
            callback()
        }
    }
    // 编辑表单验证规则
    const editFormRules = reactive({
        start_date: [
            { required: true, message: '请选择开始日期', trigger: 'blur' }
        ],
        end_date: [
            { required: true, message: '请选择结束日期', trigger: 'blur' },
            { validator: validEndDate, trigger: 'blur' }
        ],
        msg: [
            { required: true, message: '请输入提示语', trigger: 'blur' }
        ],
        cat_type: [
            { required: true, message: '请选择品类', trigger: 'change' }
        ],
        status: [
            { required: true, message: '请选择状态', trigger: 'change' }
        ]
    })

    getList()
    return { ...toRefs(state), editFormRules, FestivalCat, onSearch, onEdit, onPageChange, tableIndex, dialogBeforeClose, submitForm,onSizeChange }
}
})
</script>

<style lang="stylus" scoped>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .el-tag {
        margin-bottom:5px;
    }
    
</style>